import React from 'react';
import { DataTable } from '../../../../common/components';
import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';
import { TableHeaderColumn } from 'react-bootstrap-table';
import getStatus from '../../../../schemas/policy';
import { push } from 'react-router-redux';
import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import selectTheme from '../../../../helpers/selectTheme';
import formatDateTime from '../../../../helpers/formatDateTime';
import formatDate from '../../../../helpers/formatDate';
import displayName from '../../../../helpers/displayName';
import { connect } from 'react-redux';
import FilterContainer from '../../../policy/components/FilterContainer/FilterContainer';

const schemeType = (cell) => {
  return displayName(cell.scheme_type);
};

const startDate = (cell) => {
  if (!cell.start_date) {
    return '';
  }
  return formatDate(cell.start_date);
};

const endDate = (cell) => {
  if (!cell.end_date) {
    return '';
  }
  return formatDate(cell.end_date);
};

const destinations = (cell) => {
  let scheme_type = cell.scheme_type;
  let destinations = cell.destinations;

  if (scheme_type === 'single') {
    return destinations.join('<br>');
  } else return '';
};

const QUOTE_VERSION_OPTIONS = [
  { label: 'Current', value: '' },
  {
    label: 'All',
    value: 'all',
  },
];

const CustomerApplications = ({
  customerId,
  onGoTo,
  onApplyFilter,
  availableProducts,
}) => {
  const handleRowClick = (row) => {
    onGoTo(`/policies/applications/${row.id}`);
  };

  const handleFilterUpdate = (option) => {
    onApplyFilter('applications', 'filter[version]', option?.value ?? '');
  };

  const handleProductChange = (option) => {
    onApplyFilter('applications', 'filter[product]', option?.value ?? '');
  };
  return (
    <>
      <Row>
        <Col sm={3}>
          <FilterContainer label={'Quote Version'}>
            <Select
              isClearable
              theme={selectTheme}
              onChange={handleFilterUpdate}
              options={QUOTE_VERSION_OPTIONS}
            />
          </FilterContainer>
        </Col>
        <Col sm={4}>
          <FilterContainer label={'Product'}>
            <Select
              theme={selectTheme}
              onChange={handleProductChange}
              isClearable
              options={availableProducts.map((product) => ({
                label: product?.attributes?.name,
                value: product?.id,
              }))}
            />
          </FilterContainer>
        </Col>
      </Row>

      <DataTable
        source={'local/policies/applications'}
        autoFilter={customerId}
        autoFilterType="filter[customer]"
        name="applications"
        showTotal
        onRowSelect={handleRowClick}
      >
        <TableHeaderColumn dataField="id" isKey hidden />

        <TableHeaderColumn dataField="quote_reference" width={'110px'}>
          Quote Reference
        </TableHeaderColumn>

        <TableHeaderColumn dataField="version" width={'70px'} dataAlign={'center'}>
          Version
        </TableHeaderColumn>

        <TableHeaderColumn dataField="product_name" width={'90px'}>
          Product
        </TableHeaderColumn>

        <TableHeaderColumn dataField="insured" width={'130px'}>
          Insured
        </TableHeaderColumn>

        <TableHeaderColumn dataField="metadata" width={'80px'} dataFormat={schemeType}>
          Type
        </TableHeaderColumn>

        <TableHeaderColumn dataField="metadata" width={'110px'} dataFormat={startDate}>
          Start Date
        </TableHeaderColumn>

        <TableHeaderColumn dataField="metadata" width={'110px'} dataFormat={endDate}>
          End Date
        </TableHeaderColumn>

        <TableHeaderColumn dataField="metadata" width={'120px'} dataFormat={destinations}>
          Destinations
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="status"
          dataSort
          width={'100px'}
          dataFormat={getStatus}
        >
          Status
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="created_at"
          dataFormat={formatDateTime}
          dataSort
          width={'100px'}
        >
          Quote Date
        </TableHeaderColumn>
      </DataTable>
    </>
  );
};
export default connect(
  null,
  {
    onGoTo: push,
    onApplyFilter: applyFilter,
  },
)(CustomerApplications);
